import { useState } from 'react';
import { supabase } from '../../../lib/supabaseClient';

export default function FormularioInfluencer() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    instagram: '',
    seguidores: '',
    motivacao: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Salvar na tabela leads_qualificados com origem "influencer"
      const { error: insertError } = await supabase
        .from('leads_qualificados')
        .insert([{
          nome: formData.nome,
          email: formData.email,
          instagram: formData.instagram,
          seguidores: formData.seguidores,
          motivacao: formData.motivacao,
          origem: 'influencer',
          status: 'pendente',
          created_at: new Date().toISOString()
        }]);

      if (insertError) throw insertError;

      setSuccess(true);
      setFormData({
        nome: '',
        email: '',
        instagram: '',
        seguidores: '',
        motivacao: ''
      });

      // Scroll to success message
      setTimeout(() => {
        document.getElementById('success-message')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);

    } catch (err: any) {
      console.error('Erro ao enviar formulário:', err);
      setError('Erro ao enviar sua aplicação. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  if (success) {
    return (
      <section id="success-message" className="py-24 bg-white">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="w-24 h-24 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-8">
            <i className="ri-check-line text-5xl text-white"></i>
          </div>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Aplicação Enviada com Sucesso!
          </h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Obrigada por se candidatar ao Programa de Parceria! A Bia Holmes irá analisar sua aplicação e entrar em contato em até 48 horas.
          </p>
          <div className="p-6 bg-amber-50 rounded-2xl border border-amber-200">
            <p className="text-gray-700">
              <strong className="text-amber-700">Próximos passos:</strong> Você receberá um email com mais informações sobre a parceria e seu código exclusivo após a aprovação.
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="formulario" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-amber-100 rounded-full mb-6">
            <i className="ri-edit-line text-amber-600"></i>
            <span className="text-sm font-semibold text-amber-800 tracking-wide">FORMULÁRIO DE APLICAÇÃO</span>
          </div>
          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Candidate-se Agora
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Preencha o formulário abaixo e faça parte do time de influencers que estão transformando vidas
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="bg-gradient-to-br from-amber-50 to-white p-10 rounded-3xl border-2 border-amber-100 shadow-xl">
          {error && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl text-red-700 flex items-center gap-3">
              <i className="ri-error-warning-line text-xl"></i>
              <span>{error}</span>
            </div>
          )}

          <div className="space-y-6">
            {/* Nome */}
            <div>
              <label htmlFor="nome" className="block text-sm font-semibold text-gray-700 mb-2">
                Nome Completo *
              </label>
              <input
                type="text"
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                required
                className="w-full px-5 py-4 bg-white border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:ring-4 focus:ring-amber-100 transition-all text-gray-900"
                placeholder="Seu nome completo"
              />
            </div>

            {/* Email */}
            <div>
              <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                Email *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-5 py-4 bg-white border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:ring-4 focus:ring-amber-100 transition-all text-gray-900"
                placeholder="seu@email.com"
              />
            </div>

            {/* Instagram */}
            <div>
              <label htmlFor="instagram" className="block text-sm font-semibold text-gray-700 mb-2">
                Instagram *
              </label>
              <div className="relative">
                <span className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-400">@</span>
                <input
                  type="text"
                  id="instagram"
                  name="instagram"
                  value={formData.instagram}
                  onChange={handleChange}
                  required
                  className="w-full pl-10 pr-5 py-4 bg-white border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:ring-4 focus:ring-amber-100 transition-all text-gray-900"
                  placeholder="seuinstagram"
                />
              </div>
            </div>

            {/* Seguidores */}
            <div>
              <label htmlFor="seguidores" className="block text-sm font-semibold text-gray-700 mb-2">
                Número de Seguidores *
              </label>
              <select
                id="seguidores"
                name="seguidores"
                value={formData.seguidores}
                onChange={handleChange}
                required
                className="w-full px-5 py-4 bg-white border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:ring-4 focus:ring-amber-100 transition-all text-gray-900 cursor-pointer"
              >
                <option value="">Selecione uma faixa</option>
                <option value="1k-5k">1.000 - 5.000</option>
                <option value="5k-10k">5.000 - 10.000</option>
                <option value="10k-50k">10.000 - 50.000</option>
                <option value="50k-100k">50.000 - 100.000</option>
                <option value="100k+">Mais de 100.000</option>
              </select>
            </div>

            {/* Motivação */}
            <div>
              <label htmlFor="motivacao" className="block text-sm font-semibold text-gray-700 mb-2">
                Por que você quer ser parceira do Método Bia Holmes? *
              </label>
              <textarea
                id="motivacao"
                name="motivacao"
                value={formData.motivacao}
                onChange={handleChange}
                required
                maxLength={500}
                rows={5}
                className="w-full px-5 py-4 bg-white border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:ring-4 focus:ring-amber-100 transition-all text-gray-900 resize-none"
                placeholder="Conte um pouco sobre você e por que quer fazer parte deste programa..."
              />
              <div className="text-right text-sm text-gray-500 mt-2">
                {formData.motivacao.length}/500 caracteres
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full mt-8 px-10 py-5 bg-gradient-to-r from-amber-600 to-amber-500 text-white rounded-full font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3 whitespace-nowrap"
          >
            {loading ? (
              <>
                <i className="ri-loader-4-line text-xl animate-spin"></i>
                <span>Enviando...</span>
              </>
            ) : (
              <>
                <span>Enviar Aplicação</span>
                <i className="ri-send-plane-fill text-xl"></i>
              </>
            )}
          </button>

          {/* Privacy Note */}
          <p className="text-sm text-gray-500 text-center mt-6">
            Ao enviar, você concorda com nossa política de privacidade. Seus dados serão usados apenas para análise da parceria.
          </p>
        </form>
      </div>
    </section>
  );
}